<template>
<div class="field">
  <div class="field">
    <label class="label">Categories</label>
    <div class="control">
      <div class="tile is-ancestor">
        <div class="tile is-parent is-6">
          <div class="tile is-child">
            <b-field>
              <b-input ref="newTags" v-model="newTags" expanded placeholder="New categories separated by space" type="text"/>
              <p class="control">
                <button class="button is-info" @click.stop.prevent="onNewTags">Add</button>
              </p>
            </b-field>
            <!--
            <input v-model="newTags" ref="newTags" class="input" type="text"
            placeholder="New categories separated by space" @keydown.enter.stop.prevent="onNewTags">
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="field">
    <div class="control">
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <div class="tile is-child box">
            <p class="is-size-7 tags-label has-text-weight-bold">Available</p>
            <div class="tags">
              <span v-for="(t, index) in availTags" :key="index"
              class="tag is-link" @click="selectTag(index)" role="button">
                {{t}}
              </span>
            </div>
          </div>
        </div>
        <div class="tile is-parent">
          <div class="tile is-child box">
            <p class="is-size-7 tags-label has-text-weight-bold">Selected</p>
            <div class="tags">
              <span v-for="(t, index) in selectedTags" :key="index" role="button"
              :class="[ tagsMeta[t].flash ? 'is-danger' : (tagsMeta[t].orig ? 'is-link' : 'is-primary'), 'tag' ]" @click="unselectTag(index)">
                {{t}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'new-categories',
  props: {
    available: {
      type: Array,
    },
    value: {         // selected tags
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      newTags: null,
      availTags: this.available.slice(0),
      tagsMeta: this.available.reduce((obj, tag) => {
        obj[tag] = { orig: true, flash: false };
        return obj;
      }, {}),
      preventChanges: false,
    };
  },
  computed: {
    selectedTags: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    selectTag(index, force) {
      if (force || !this.preventChanges) {
        const selected = this.availTags.splice(index, 1);
        this.selectedTags.push(...selected);
        this.setFocusOnInput();
      }
    },
    unselectTag(index) {
      if (!this.preventChanges) {
        const unselected = this.selectedTags.splice(index, 1);
        if (this.tagsMeta[unselected[0]].orig) {
          this.availTags.push(...unselected);
        }
        this.setFocusOnInput();
      }
    },
    onNewTags() {
      if (this.preventChanges) {
        return;
      }

      const newTags = this.newTags.toLowerCase().split(/\s+/);
      const newTagsTracker = {};
      let clearText = false;

      newTags.forEach((newTagTemp) => {
        const newTag = newTagTemp.trim();

        if (newTag && !newTagsTracker[newTag]) {
          newTagsTracker[newTag] = 1;
          let index = this.availTags.indexOf(newTag);
          if (index >= 0) {
            this.selectTag(index, true);
            clearText = true;
          } else {
            index = this.selectedTags.indexOf(newTag);
            if (index < 0) {
              this.selectedTags.push(newTag);
              Vue.set(this.tagsMeta, newTag, { orig: false, flash: false });
              clearText = true;
            } else {
              this.flashTag(this.selectedTags[index]);
            }
          }
        }
      });

      if (clearText) {
        this.newTags = '';
      } else {
        this.setFocusOnInput();
      }
    },
    setFocusOnInput() {
      if (!this.isMobile()) {
        const bInput = this.$refs.newTags;
        bInput.focus(); // buefy input supports focus, but not select
        bInput.$el.querySelector('input').select();
      }
    },
    flashTag(tag) {
      this.preventChanges = true;
      const self = this;

      setTimeout(() => {
        let count = 5;
        const ms = 200;
        Vue.set(this.tagsMeta[tag], 'flash', true);

        const flashTagHelper = () => {
          Vue.set(this.tagsMeta[tag], 'flash', !this.tagsMeta[tag].flash);
          count -= 1;
          if (count) {
            setTimeout(flashTagHelper, ms);
          } else {
            self.preventChanges = false;
          }
        };

        setTimeout(flashTagHelper, ms);
      }, 0);
    },
  },
};
</script>

<style lang="sass" scoped>
.tags-label
  padding-bottom: 20px
</style>



// WEBPACK FOOTER //
// src/components/NewCategories.vue